import { alpha, styled } from "@mui/material/styles";
import { DataGridPro, gridClasses } from "@mui/x-data-grid-pro";
import {
	dataGridCellClassNames,
	dataGridRowClassNames,
} from "src/components/common/dataGrid/styles/dataGridClassNames.ts";

export const StyledDataGrid = styled(DataGridPro)(({ theme, listView }) => ({
	"--DataGrid-containerBackground": theme.palette.grey[100],
	border: "none",
	[`& .${gridClasses["container--top"]}`]: {
		minHeight: "auto",
	},
	[`& .${gridClasses.columnHeaders}`]: {
		paddingLeft: "3px",
	},
	[`& .${gridClasses.columnHeader}`]: {
		backgroundColor: "#edf3f2",
		color: "#2c5e56",
		fontWeight: 600,
		fontSize: theme.typography.body2.fontSize,
		letterSpacing: "0.01em",
		textTransform: "none" as const,
		[`& .${gridClasses.iconButtonContainer}`]: {
			"& .MuiIconButton-root": {
				padding: "0.0125rem",
				marginLeft: "0.25rem",
			},
		},
	},
	[`& .${gridClasses["row--borderBottom"]} .${gridClasses.columnHeader}`]: {
		borderBottom: "1px solid #d1e1de",
	},
	[`& .${gridClasses.columnSeparator}`]: {
		color: "rgba(44,94,86,0.2)",
	},
	[`& .${gridClasses.footerContainer}`]: {
		minHeight: "1.5rem",
		height: "1.5rem",
		alignItems: "stretch",
		fontSize: "0.75rem",
		borderTop: `1px solid ${theme.palette.grey[200]}`,
		"& .MuiTablePagination-root": {
			display: "flex",
			alignItems: "stretch",
			overflow: "hidden",
			fontSize: "inherit",
		},
		"& .MuiTablePagination-toolbar": {
			minHeight: 0,
			"& > *": {
				marginBottom: 0,
				marginTop: 0,
			},
		},
		"& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows": {
			fontSize: "inherit",
		},
	},
	[`& .${gridClasses.row}`]: {
		borderLeft: "3px solid transparent",
		backgroundColor: theme.palette.background.paper,
		transition: "background-color 0.1s ease",
		"&:hover, &.Mui-hovered": {
			backgroundColor: alpha(theme.palette.primary.main, 0.04),
			"@media (hover: none)": {
				backgroundColor: "transparent",
			},
		},
		"&.Mui-selected": {
			backgroundColor: alpha(theme.palette.primary.main, 0.12),
			borderLeft: `3px solid ${theme.palette.primary.main}`,
			"&:hover, &.Mui-hovered": {
				backgroundColor: alpha(theme.palette.primary.main, 0.18),
				"@media (hover: none)": {
					backgroundColor: alpha(theme.palette.primary.main, 0.12),
				},
			},
		},
	},
	[`& .${gridClasses.cell}`]: {
		borderBottomColor: theme.palette.grey[200],
		paddingTop: listView ? "0.4rem" : undefined,
		paddingBottom: listView ? "0.4rem" : undefined,
		fontSize: theme.typography.body2.fontSize,
		"&:focus, &:focus-within": {
			outline: `1.5px solid ${alpha(theme.palette.primary.main, 0.5)}`,
			outlineOffset: -1,
		},
	},
	[`& .${dataGridRowClassNames.edited}`]: {
		backgroundColor: alpha("#ffd600", 0.1),
	},
	[`& .${dataGridRowClassNames.unsavedNew}`]: {
		backgroundColor: alpha(theme.palette.success.light, 0.12),
	},
	[`& .${dataGridRowClassNames.green}`]: {
		backgroundColor: alpha(theme.palette.green.light, 0.5),
	},
	[`& .${dataGridRowClassNames.yellow}`]: {
		backgroundColor: alpha(theme.palette.yellow.light, 0.25),
	},
	[`& .${dataGridRowClassNames.red}`]: {
		backgroundColor: alpha(theme.palette.error.light, 0.4),
	},
	[`& .${dataGridRowClassNames.invalid}`]: {
		borderLeft: `3px solid ${theme.palette.error.main}`,
		backgroundColor: alpha(theme.palette.error.main, 0.05),
		"&:hover, &.Mui-hovered": {
			backgroundColor: alpha(theme.palette.error.main, 0.09),
		},
	},

	[`& .${dataGridCellClassNames.borderColorError}`]: {
		border: `2px solid ${theme.palette.error.main}`,
	},
	[`& .${dataGridCellClassNames.backgroundColorWarning}`]: {
		backgroundColor: theme.palette.warning.main,
		color: theme.palette.warning.contrastText,
	},
	[`& .${dataGridCellClassNames.backgroundColorError}`]: {
		backgroundColor: alpha(theme.palette.error.light, 0.4),
	},
	[`& .${dataGridCellClassNames.textColorSuccess}`]: {
		color: theme.palette.success.main,
	},
	[`& .${dataGridCellClassNames.textColorError}`]: {
		color: theme.palette.error.main,
	},
})) as typeof DataGridPro;
